<template>
  <div
    class="el-table-editabled-cell"
    :class="{'is-validate-error': !!ownStates.validateMsg}"
    @mouseenter="() => ownStates.hovering = true"
    @mouseleave="() => ownStates.hovering = false"
  >
    <el-tooltip
      :disabled="!editValidator.validateMsgTooltip"
      :value="!!ownStates.validateMsg && ownStates.hovering"
      popper-class="el-table-editabled-cell-validate-msg"
      effect="light"
      :content="ownStates.validateMsg"
      placement="top-start"
      manual
    >
      <div class="el-table-editabled-cell__content">
        <slot
          :cellStates="cellStates"
          :rowStates="rowStates"
          :ownStates="ownStates"
          :validateOwn="validateOwn"
        ></slot>
      </div>
    </el-tooltip>
    <div
      v-if="!editValidator.validateMsgTooltip"
      v-show="!!ownStates.validateMsg"
      class="el-table-editabled-cell__error-msg"
    >
      {{ownStates.validateMsg}}
    </div>
  </div>
</template>

<script>
import { isObject, isFunction } from '../../../utils'

export default {
  name: 'ElTableEditabledCell',
  inject: ['editValidator'],
  props: {
    prop: String,
    row: null,
    dependencies: Object
  },
  computed: {
    rowStates () {
      return this.cellStates._states
    },
    cellStates () {
      return this.editValidator.store.getStates(this.row)
    },
    ownStates () {
      return this.cellStates && this.prop ? this.cellStates[this.prop] : {}
    }
  },
  created () {
    if (this.dependencies) {
      Object.keys(this.dependencies).forEach(target => {
        const watcherOptions = this.dependencies[target]
        const watcherHandler = (newVal, oldVal, cb) => {
          cb(newVal, oldVal, this.row, this.ownStates, this.cellStates, this.rowStates)
        }

        if (isObject(watcherOptions)) {
          this.$watch(
            target,
            (newVal, oldVal) => watcherHandler(newVal, oldVal, watcherOptions.handler),
            watcherOptions
          )
        } else if (isFunction(watcherOptions)) {
          this.$watch(target, (newVal, oldVal) => watcherHandler(newVal, oldVal, watcherOptions))
        }
      })
    }
  },
  methods: {
    validateOwn (cb) {
      this.editValidator.validateCells([this.row], [this.prop], cb)
    }
  }
}
</script>
